import LoginManagementService from '@assets/js/imaios-connection-management/login-management-service';
import { pubsub } from '@assets/js/imaios-global/imaios-global';
import '@imaios-js/anatomy/dist/anatomy-china';
import './anatomy-module-css.index.scss';

const ANONYMOUS_USER_ID = 'faaeb9be3bd98ed09f606fc16d144eca';

LoginManagementService.awaitConnection().then(() => {
	const userInformation = LoginManagementService.getLocalUserData();
	pubsub.publish('update-anatomy-user-id', userInformation.id ?? ANONYMOUS_USER_ID);
});
